import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HashLink from '../HashLink/HashLink';
import { CONTACT } from '../../data/contactDetails';
import { IconMail, IconPhone, IconLocation, IconClock } from '../icons/ContactIcons';
import { SOCIAL_ICON_MAP } from '../icons/SocialIcons';

const FOOTER_SERVICES = [
  'Custom Software Development',
  'Web Application Development',
  'Mobile App Development',
  'Cloud, DevOps & Managed IT',
  'UI / UX & Product Design',
  'API Integration & Automation',
];

function FooterContactRow({ icon, children }) {
  return (
    <li className="footer-contact-item">
      <span className="footer-icon">{icon}</span>
      <div className="footer-contact-body">{children}</div>
    </li>
  );
}

const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  const goHome = (e) => {
    e.preventDefault();
    navigate('/');
    window.history.replaceState(null, '', '/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="CodeInventiv Solutions home" onClick={goHome}>
            <img
              className="site-logo"
              src="/logos/01_primary_logo_dark-removebg-preview.png?v=5"
              alt="CodeInventiv Solutions"
              width="320"
              height="64"
              decoding="async"
            />
          </Link>
          <p className="footer-tag">
            Custom software, web applications, and mobile apps for growing businesses.
            Founded in 2025 · Jaipur, India.
          </p>
          <div className="footer-social">
            {CONTACT.social.map((s) => {
              const SocialIcon = SOCIAL_ICON_MAP[s.name];
              return (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  aria-label={s.label}
                >
                  {SocialIcon ? <SocialIcon /> : s.label}
                </a>
              );
            })}
          </div>
        </div>

        <div className="footer-cols">
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/services">Services</Link>
            <Link to="/about">About Us</Link>
            <Link to="/industries">Industries</Link>
            <Link to="/technologies">Technologies</Link>
            <HashLink to="#work">Our Work</HashLink>
            <Link to="/contact">Contact Us</Link>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            {FOOTER_SERVICES.map((name) => (
              <Link key={name} to="/services">
                {name}
              </Link>
            ))}
          </div>

          <div className="footer-col footer-col-contact">
            <h4>Get In Touch</h4>
            <ul className="footer-contact-list">
              <FooterContactRow icon={<IconMail />}>
                <a className="footer-email-link" href={`mailto:${CONTACT.email}`}>
                  {CONTACT.email}
                </a>
              </FooterContactRow>

              <FooterContactRow icon={<IconPhone />}>
                {CONTACT.phones.map((p) => (
                  <a key={p.label} href={`tel:${p.tel}`}>
                    {p.label}: {p.display}
                  </a>
                ))}
              </FooterContactRow>

              <FooterContactRow icon={<IconLocation />}>
                {CONTACT.offices
                  .filter((office) => office.label.startsWith('India'))
                  .map((office) => (
                    <p key={office.label} className="footer-text">
                      {office.lines.join(', ')}
                    </p>
                  ))}
              </FooterContactRow>

              <FooterContactRow icon={<IconClock />}>
                <p className="footer-text">{CONTACT.workingHours}</p>
              </FooterContactRow>
            </ul>
          </div>
        </div>
      </div>

      <div className="container footer-base">
        <small>© {year} CodeInventiv Solutions. All rights reserved.</small>
        <div className="footer-meta">
          <span>Jaipur, India</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
